import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0055',
    ecrans: ['01-2']
});
